import { bankMessages } from '@shared/bank-messages-config';
import { exportFeatures, transactions } from '@retail/transactions-config';
import { thirdPartyProviders } from '@shared/third-party-providers-config';
import { infoApi } from '@shared/info-api-config';
import { profileConfig } from '@retail/profile-config';
import { documentsAndRequests } from '@shared/documents-and-requests-config';
import _ from '@luna/lodash';
import { aboutYouConfig } from '@retail/about-you-config';
import { contactDataManagement } from '@shared/contact-data-management-config';
import { gdpr } from '@retail/profile-administration-config';
import { kyc } from '@retail/kyc-config';
import { messenger } from '@shared/messenger-config';
import { cards } from '@retail/cards-config';
import { overview } from '@retail/overview-config';
import { plugins } from '@retail/plugins-config';
import {
    AccountsCurrentFeatureConfig,
    AccountsFeatureConfig,
    BuildingSocietyFeatureConfig,
    ProductsFeatureConfig,
    SavingsFeatureConfig,
    StatementFeatureConfig,
} from '@retail/products-config';
import { supportChatFeatureConfigMap } from '@shared/support-chat-config';
import { featureConfigMap as contactAreaFeatureConfigMap } from '@retail/contact-area-config';
import { notificationsFeatureConfig } from '@retail/notifications-config';
import { consents } from '@retail/consents-config';

import { arrayOverwrite, baseFeatureConfig, extendFeatureConfigFromUrl } from './base';
import type { PartialRetailFeatureConfig } from './featureConfig';

export const countryFeatureConfig: PartialRetailFeatureConfig = {
    aboutYou: aboutYouConfig.AT,
    bankMessages: bankMessages.AT,
    contactDataManagement: contactDataManagement.AT,
    documentsAndRequests: documentsAndRequests.AT,
    gdpr: gdpr.AT,
    kyc: kyc.AT,
    consents: consents.AT,
    messenger: messenger.AT,
    thirdPartyProviders: thirdPartyProviders.AT,
    cards: cards.AT,
    overview: overview.AT,
    plugins: plugins.AT,
    statements: StatementFeatureConfig.AT,
    transactions: transactions.AT,
    export: exportFeatures.AT,
    savings: SavingsFeatureConfig.AT,
    supportChat: supportChatFeatureConfigMap.AT,
    contactArea: contactAreaFeatureConfigMap.AT,
    notifications: notificationsFeatureConfig.AT,
    base: {
        allowedLanguages: ['de', 'en'],
        availableLanguages: ['de', 'en'],
        supportedSyntheticLanguages: ['fr'],
        defaultLanguage: 'de',
        sendLanguageHeader: true,
        preferWebApiLanguage: true,
        defaultTimezone: 'Europe/Vienna',
        passCredentialsInRequest: true,
    },
    footer: {
        links: {
            imprint: {
                de: 'https://www.sparkasse.at/{INSTITUTE_ID}-impressum-de',
                en: 'https://www.sparkasse.at/{INSTITUTE_ID}-impressum-en',
            },
            privacy: {
                de: 'https://www.sparkasse.at/tiny/datenschutz-george',
                en: 'https://www.sparkasse.at/tiny/datenschutz-george-en',
            },
            termsAndConditions: {
                de: 'https://www.sparkasse.at/tiny/gbg-george',
                en: 'https://www.sparkasse.at/tiny/gbg-george-en',
            },
        },
    },
    accounts: AccountsFeatureConfig.AT,
    currentAccount: AccountsCurrentFeatureConfig.AT,
    buildingSociety: BuildingSocietyFeatureConfig.AT,
    handover: {
        handoverTokenExchange: true,
    },
    infoApi: infoApi.AT,
    autoLogout: {
        timeoutInSeconds: 900, // AT thinks that PSD2's 5min rule does not apply here
        timerThreshold: 300,
        alertThreshold: 60,
    },
    devTools: {
        availableApiTargets: {
            'FAT 1': ['https://api.fat.sparkasse.at/f1', 'https://messaging.fat.sparkasse.at/fat1'],
            'FAT 2': ['https://api.fat.sparkasse.at/f2', 'https://messaging.fat.sparkasse.at/fat2'],
            'FAT 3': ['https://api.fat.sparkasse.at/f3'],
        },
        availableEnvironments: {
            Local: 'http://localhost:8080',
            Dev: 'https://at.dev.beeone.at',
            'FAT 1': 'https://george.fat.sparkasse.at',
            'FAT 2': 'https://george.fat2.sparkasse.at',
            'FAT 3': 'https://george.fat3.sparkasse.at',
            'FAT 4': 'https://george.fat4.sparkasse.at',
            'FAT AWS': 'https://george.fat.aws.sparkasse.at',
            LTP: 'https://george.lpt.sparkasse.at',
            SEP: 'https://george.sep.sparkasse.at',
        },
    },
    profileConfiguration: profileConfig.AT,
    tracking: {
        appId: 'INT55',
        appName: 'GeorgeWeb_Retail_AT',
    },
    products: ProductsFeatureConfig.AT,
    allowedRedirectDomains: ['sparkasse.at'],
};

const featuresWithBase: any = _.merge({}, baseFeatureConfig, countryFeatureConfig, arrayOverwrite);
export const featureConfig = extendFeatureConfigFromUrl(featuresWithBase);
